import styled from 'styled-components';
import MuiTextField from '@material-ui/core/TextField';

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 48px;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  @media (min-width: 768px) {
    padding: 32px 16px 64px;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 480px) {
    max-width: 480px;
  }
`;

export const StepDots = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const StepDot = styled.div`
  width: ${({ active }) => (active ? '38px' : '12px')};
  height: 12px;
  border-radius: 6px;
  background-color: ${({ active }) => (active ? '#00843d' : '#D8D8D8')};
  transition: all 0.3s;
`;

export const StepLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: #676767;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const Card = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;

  @media (min-width: 480px) {
    max-width: 480px;
    padding: 40px 32px;
    border-radius: 16px;
  }
`;

export const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e8f5e9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const CardTitle = styled.h1`
  font-size: 26px;
  font-weight: bold;
  color: #181818;
  margin: 0;
  line-height: 1.2;

  @media (min-width: 480px) {
    font-size: 32px;
  }
`;

export const CardDescription = styled.p`
  font-size: 15px;
  color: #676767;
  margin: 0;
  line-height: 1.6;

  @media (min-width: 480px) {
    font-size: 16px;
    max-width: 320px;
  }
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 16px;
  background-color: #00ae42;
  color: #ffffff;
  font-family: Avenir, -apple-system, sans-serif;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  transition: background 0.25s;

  &:hover {
    background-color: #0dd260;
  }

  &:disabled {
    background-color: #f3f3f3;
    color: #919090;
    cursor: default;
  }
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  color: #00843d;
  font-family: Avenir, -apple-system, sans-serif;
  font-size: 15px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  padding: 4px 0;
  transition: opacity 0.25s;

  &:hover {
    opacity: 0.7;
  }
`;

export const InfoBox = styled.div`
  width: 100%;
  border: 1px dashed #d5d5d5;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  font-size: 13px;
  color: #676767;
  line-height: 1.5;

  strong {
    color: #181818;
    font-weight: bold;
  }

  @media (min-width: 480px) {
    max-width: 480px;
  }
`;

export const FormGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
`;

export const FormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #5d5d5d;
  font-weight: 500;
`;

export const StyledTextField = styled(MuiTextField)`
  width: 100%;

  & .MuiFilledInput-root {
    background-color: #f5f5f5;
    border-radius: 8px;

    &:hover {
      background-color: #eeeeee;
    }

    &.Mui-focused {
      background-color: #f5f5f5;
    }
  }

  & .MuiFormLabel-root.Mui-focused {
    color: #00843d;
  }

  & .MuiInputBase-input,
  & .MuiSelect-select {
    font-family: Avenir, -apple-system, sans-serif;
    font-size: 15px;
    text-align: left;
  }
`;

export const CheckboxWrapper = styled.div`
  width: 100%;
  text-align: left;

  & .MuiFormControlLabel-label {
    font-family: Avenir, -apple-system, sans-serif;
    font-size: 14px;
    color: #181818;
  }

  & .MuiCheckbox-colorPrimary.Mui-checked {
    color: #00843d;
  }
`;

export const CardBodyLeft = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
`;

export const AlertRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const AlertIconBox = styled.div`
  width: 60px;
  min-width: 60px;
  height: 60px;
  border-radius: 12px;
  background-color: #fff8e1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SectionLabel = styled.p`
  font-size: 15px;
  font-weight: 500;
  color: #181818;
  margin: 0;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  margin-top: 8px;

  & > * {
    flex: 1;
    margin-top: 0;
  }
`;

export const OutlineButton = styled.button`
  padding: 8px;
  background-color: transparent;
  color: #00843d;
  font-family: Avenir, -apple-system, sans-serif;
  font-size: 16px;
  font-weight: bold;
  border: 2px solid #00843d;
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background 0.25s;

  &:hover {
    background-color: #f0faf4;
  }
`;
